module.exports = __webpack_public_path__ + "static/media/miss_target.c0ed233d.png";